<p-toast key="ajustement"></p-toast>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>



<div #contenu *ngIf="EstCharge()">

    <div class="col-12">
        <p-card>
            <div class="fluid formgrid grid">
                <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4">
                    <label for="lastname">Date</label>
                    <p-calendar appendTo="body" showIcon=true [(ngModel)]="ajustement.date" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
                    <small class="p-error" *ngIf="submitted && !ajustement.date">La date est obligatoire.</small>
                </div>
                <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4">
                    <label for="chauffeur">Nb heures ancien compteur</label>
                    <p-inputNumber #champNbHeures  [(ngModel)]="ajustement.nbHeuresAvant" (keyup.enter)="creerReleveHeure()"></p-inputNumber>
                    <small class="p-error" *ngIf="submitted && !ajustement.nbHeuresAvant">Le nombre d'heures de l'ancien compteur est obligatoire.</small>
                </div>
                <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-4">
                    <label for="chauffeur">Nb heures nouveau compteur</label>
                    <p-inputNumber #champNbHeures  [(ngModel)]="ajustement.nbHeuresApres" (keyup.enter)="creerReleveHeure()"></p-inputNumber>
                    <small class="p-error" *ngIf="submitted && !ajustement.nbHeuresApres && ajustement.nbHeuresApres != 0">Le nombre d'heures du nouveau compteur est obligatoire.</small>
                </div>
            </div>

            <div class="grid">
                <div class="col-12 text-right mt-3">
                    <button pButton pRipple label="Confirmer" icon="pi pi-save" class="p-button-primary"
                        (click)="confirmer()"></button>
                    <button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text"
                        (click)="annuler()"></button>
                </div>
            </div>

        </p-card>
    </div>

</div>